import React, {useEffect} from "react";
import Button from "../ui-components/Button";
import Select from "../ui-components/Select";


const DEFAULT_OUTPUT_OBJ = {
  label_question: null,
  color_question: null,
  system_question: null,
  primers_question: null,
  surface_question: null
};


const ServiceConfiguratorBlockCalculationKCCOptimizationGenerator = ({
  kccOptimization,
  updateKccOptimization,
  questions,
  setSelectedOperator,
  editable=true,
}) => {

  const kccOptimizationObject = kccOptimization === "kcc_optimization"
    ? {...DEFAULT_OUTPUT_OBJ, original: kccOptimization}
    : JSON.parse(kccOptimization);

  useEffect(() => {
    if (editable)
      updateKccOptimization(kccOptimizationObject)
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const filterQuestionsByInputType = (type) => questions
    .filter((q) => q.input_type === type)
    .map((q) => ({
      name: q.name || `Question ${q.id}`,
      value: q.id,
    }));

  return (
    <div className="flex flex-col w-full mb-8 mt-8">
      <div className=" mb-2 flex text-center justify-center">
        <p className="font-bold">KCC OPTIMIZATION GENERATOR</p>
      </div>

      <Select
        label="Select configuration name question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('text_input')
        ]}
        value={kccOptimizationObject.label_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            label_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select KCC color question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('kcc_color_input')
        ]}
        value={kccOptimizationObject.color_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            color_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select system question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('select')
        ]}
        value={kccOptimizationObject.system_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            system_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select primers question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('select')
        ]}
        value={kccOptimizationObject.primers_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            primers_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select rete question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('select')
        ]}
        value={kccOptimizationObject.reti_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            reti_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select rasante question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('select')
        ]}
        value={kccOptimizationObject.rasanti_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            rasanti_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      <Select
        label="Select surface question"
        options={[
          { value: "", name: "" },
          ...filterQuestionsByInputType('number_input')
        ]}
        value={kccOptimizationObject.surface_question || ""}
        onChange={(e) =>
          updateKccOptimization({
            ...kccOptimizationObject,
            surface_question: parseInt(e.target.value)
          })
        }
        disabled={!editable}
      />

      {editable && <div className="mt-4 flex justify-end">
        <Button onClick={() => setSelectedOperator(null)}>DONE</Button>
      </div>}
    </div>
  );
};

export default ServiceConfiguratorBlockCalculationKCCOptimizationGenerator;
